import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  Chip,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import dayjs from "dayjs";
import { DropzoneArea } from "material-ui-dropzone";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";
import ROUTER from "../../../constants/router";

import { uploadFile, uploadMultiFile } from "../../../reducer/file/action";
import KPTimePicker from "../../../components/KPTimePicker";
import { updatePatent, acceptPatent, requestRevisionPatent } from "../../../reducer/patent/action";
import { ModalWorkflowActions } from "../../../components/WorkflowStatus";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import {
  getEmploymentContractById,
  getAllEmploymentContractByProfileId,
} from "../../../reducer/employmentContract/action";

import FilePreviewModal from "../../File/FilePreviewModal";
import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import moment from "moment";

function PatentUpdateModal(props) {
  const { employmentContractDetail, updating, setUpdating, updatePatent } = props;
  const [disabled, setDisabled] = useState(false);

  const [values, setValues] = useState(null);
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [files, setFiles] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [timeResearchYear, setTimeResearchYear] = useState(0);
  const [timeResearchDetailList, setTimeResearchDetailList] = useState([]);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);

  useEffect(() => {
    if (updating) resetValues();
  }, [updating]);

  useEffect(() => {
    if (employmentContractDetail)
      setValues({
        ...values,
        profileIdForKpi: employmentContractDetail?.profile?.id,
      });
  }, [employmentContractDetail]);

  useEffect(() => {
    if (values?.profileIdForKpi) props.getAllEmploymentContractByProfileId(values?.profileIdForKpi);
  }, [values?.profileIdForKpi]);

  useEffect(() => {
    if (values?.timeResearchDetailCode) {
      const selectedYear = props.timeResearchInformationList?.find(
        (info) => !!info.timeResearchDetail.find((detail) => detail.code === values?.timeResearchDetailCode),
      )?.year;

      setTimeResearchYear(selectedYear);
    }
  }, [values?.timeResearchDetailCode]);

  useEffect(() => {
    // setDetail(props?.employmentContractListById?.find((e) => e?.contract?.id === updating?.contractIdForKpi)?.contract);
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === updating?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === updating.kpiIdForKpi));
  }, [props?.employmentContractListById, updating?.contractIdForKpi]);

  useEffect(() => {
    if (values && props.isUploading === false && props.fileUrl !== "") {
      setValues({
        ...values,
        fileUrl: props.fileUrl,
      });
      if (values?.id) {
        updatePatent(values.id, {
          ...values,
          patentProfile: profileList,
          issueAt: dateFormat(values?.issueAt),
          acceptedDay: dateFormat(values?.acceptedDay),
          submissionDay: dateFormat(values?.submissionDay),
          fileUrl: props.fileUrl,
          dashboardYear: new Date(dateFormat(values?.acceptedDay)).getFullYear(),
        });
      }
    }
  }, [props.isUploading]);

  // Bỏ KPI bỏ luôn contract
  // useEffect(() => {
  //   if (!values?.profileIdForKpi) handleChangeForm('contractIdForKpi', null);
  // }, [values?.profileIdForKpi]);

  const dateFormat = (value) => {
    const dateForm = value?.replaceAll("/", "");
    const date = dateForm?.substr(0, 2);
    const month = dateForm?.substr(2, 2);
    const year = dateForm?.substr(-4);
    return value ? dayjs(`${month}/${date}/${year}`).format("YYYY-MM-DDTHH:mm:ssZ") : null;
  };

  const resetValues = () => {
    setValues({
      ...updating,
      issueAt: dayjs(updating.issueAt)?.format("DD-MM-YYYY")?.replaceAll("-", "/"),
      acceptedDay: dayjs(updating.acceptedDay)?.format("DD-MM-YYYY")?.replaceAll("-", "/"),
      submissionDay: dayjs(updating.submissionDay)?.format("DD-MM-YYYY")?.replaceAll("-", "/"),
    });
    setProfileList([...updating.patentProfile] || []);
    if (!props.isFetchingEmploymentContract) props.getEmploymentContractById(updating.contractIdForKpi);

    const timeResearchYearId = parseInt(updating.timeResearchDetailCode?.split("-")[0]);
    const year = props.timeResearchInformationList?.find((e) => e.id === timeResearchYearId)?.year || 2022;
    setTimeResearchYear(year);
  };

  const handleChangeForm = (name, value) => {
    if (name === "timeResearchDetailCode") {
      setValues({
        ...values,
        [name]: value === "null" ? null : value,
      });
    } else if (name === "purposeId" && value !== 1) {
      setValues({
        ...values,
        [name]: value,
        profileIdForKpi: null,
        contractIdForKpi: null,
        profileIdForReward: null,
      });
    } else {
      setValues({ ...values, [name]: value });
    }
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInPatent: "main",
      statusInProject: "K",
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    if (profileList[index].profileId === values?.profileIdForKpi) handleChangeForm("profileIdForKpi", null);
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const handleClose = () => {
    resetValues();
    setUpdating(null);
    setDisabled(false);
  };

  const handleSubmit = () => {
    if (!values?.title) {
      setHelperText(true);
      return;
    }
    if (!values?.numOfOwner) {
      setHelperText(true);
      return;
    }
    // if (!updating?.dashboardId && !values?.contractIdForKpi) {
    //   alert("Thêm mới cần có hợp đồng");
    //   return;
    // }
    // if (!updating?.dashboardId && values?.lockStatus) {
    //   alert("Thêm mới không cho phép khóa bản ghi");
    //   return;
    // }
    const dashboardYear = new Date(dateFormat(values?.acceptedDay)).getFullYear();
    if (files.length > 0) {
      uploadMultiFile(files, {
        id: values.id,
        ...values,
        patentProfile: profileList,
        issueAt: dateFormat(values?.issueAt),
        acceptedDay: dateFormat(values?.acceptedDay),
        submissionDay: dateFormat(values?.submissionDay),
        dashboardYear,
      });
    } else {
      updatePatent(values.id, {
        ...values,
        patentProfile: profileList,
        issueAt: dateFormat(values?.issueAt),
        acceptedDay: dateFormat(values?.acceptedDay),
        submissionDay: dateFormat(values?.submissionDay),
        dashboardYear,
      }).then(() => {
        handleClose();
      });
    }
    setDisabled(false);
  };

  const getNoteByType = () => {
    return "Upload file minh chứng bằng sáng chế";
  };

  const handleOpenPreviewModal = () => setPreviewModalOpen(true);
  const handleClosePreviewModal = () => setPreviewModalOpen(false);

  const contractList = [];
  props?.employmentContractListById.forEach((e) => contractList.push(e.contract));

  // var timeResearchDetailList =
  //   props.timeResearchInformationList?.find((e) => e.year === timeResearchYear)
  //     ?.timeResearchDetail || [];
  // timeResearchDetailList = timeResearchDetailList.filter(
  //   (e) => !e.allowedUpdateNum && e.type?.includes("patent")
  // );

  useEffect(() => {
    if (props.timeResearchInformationList?.length > 0 && timeResearchYear) {
      let list = props.timeResearchInformationList
        ?.find((e) => e.year === timeResearchYear)
        ?.timeResearchDetail.filter((e) => !e.allowedUpdateNum && e.type?.includes("patent"));
      setTimeResearchDetailList(list || []);

      setValues({
        ...values,
        timeResearchDetailCode: null,
      });
    }
  }, [props.timeResearchInformationList, timeResearchYear]);

  const yearList = [];
  props.timeResearchInformationList
    .sort((a, b) => b.year - a.year)
    .forEach((e) => {
      yearList.push(e.year);
    });

  const renderLockButton = () => {
    if (!values?.locked) return null;
    return (
      <Chip
        variant="outlined"
        label={`Đã khóa tính ${
          (values?.locked === "kpi" && "KPI") ||
          (values?.locked === "reward" && "thưởng") ||
          (values?.locked === "timeResearch" && "giờ nghiên cứu")
        }`}
        color="primary"
        style={{ fontSize: 15, float: "right", marginRight: 16 }}
      />
    );
  };

  const handleSendFeedback = () => {
    props.history.push({
      pathname: ROUTER.NOTIFICATION,
      state: {
        sendTo: "personal",
        title: "Thông báo về sai sót thông tin trong CTKH",
        chosenProfiles: profileList.reduce((accumulator, currentValue) => {
          accumulator.push(currentValue.profileId);
          return accumulator;
        }, []),
        data: updating,
        dataType: "patent",
      },
    });
  };

  return (
    <Dialog
      open={updating !== null}
      onClose={handleClose}
      disableBackdropClick
      PaperProps={{
        style: {
          width: "calc(100vw - 240px)",
          height: "100vh",
          maxWidth: "calc(100vw - 240px)",
          maxHeight: "100vh",
          margin: "0 0 0 240px",
        },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <Typography variant="h5">{disabled ? "Chi tiết" : "Cập nhật"}</Typography>
            {renderLockButton()}
            <Button
              onClick={handleClose}
              variant="outlined"
              color="secondary"
              style={{
                marginLeft: 8,
                padding: "8px 24px",
                fontSize: "15px",
              }}
            >
              Hủy
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              style={{
                padding: "8px 24px",
                fontSize: "15px",
              }}
            >
              Lưu thay đổi
            </Button>
            <ModalWorkflowActions
              row={props.updating}
              role={props.role}
              onAccept={async () => {
                const ok = await props.acceptPatent(props.updating.id, !props.updating.accepted);
                if (ok) {
                  props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
                  if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
                }
                return ok;
              }}
              onRequestRevision={(reason) => props.requestRevisionPatent(props.updating.id, reason)}
              onAfterAction={() => props.setUpdating(null)}
            />
            {/* <Button
              color="primary"
              variant="contained"
              style={{
                padding: "8px 24px",
                fontSize: "15px",
              }}
              onClick={() => {
                window.open(
                  `${ROUTER.SEND_FEEDBACK_SCREEN}?type=patent&id=${updating?.id}`,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
            >
              Gửi feedback
            </Button> */}
          </div>
        </div>
      </DialogTitle>
      <DialogContent style={{ display: "flex", overflowX: "hidden", padding: "0" }}>
        <div
          style={{
            width: "60%",
            padding: "20px 24px",
            overflowY: "auto",
            borderRight: "1px solid #e0e0e0",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                variant="outlined"
                label="Tên bằng sáng chế"
                value={values?.title || ""}
                error={helperText && !values?.title}
                helperText={helperText && !values?.title ? "Vui lòng nhập tên bằng sáng chế" : ""}
                onChange={(event) => handleChangeForm("title", event.target.value)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                required
                fullWidth
                disabled={disabled}
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng đồng sở hữu"
                value={values?.numOfOwner || ""}
                error={helperText && !values?.numOfOwner}
                helperText={helperText && !values?.numOfOwner ? "Vui lòng nhập số lượng đồng sở hữu" : ""}
                onChange={(event) => handleChangeForm("numOfOwner", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      values={values?.isPhenikaa}
                      onChange={(event) => {
                        handleChangeForm("isPhenikaa", event.target.checked);
                      }}
                    />
                  }
                  label="Trường Đại học VinUni là Cơ quan chủ trì"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <TextField
                rows={2}
                fullWidth
                disabled={disabled}
                multiline
                size="small"
                variant="outlined"
                label="Nhóm tác giả"
                value={values?.authorTeam || ""}
                onChange={(event) => handleChangeForm("authorTeam", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng thành viên tham gia"
                value={values?.numOfMember || ""}
                error={helperText && !values?.numOfMember}
                helperText={helperText && !values?.numOfMember ? "Vui lòng nhập số lượng thành viên tham gia" : ""}
                onChange={(event) => handleChangeForm("numOfMember", parseInt(event.target.value))}
              />
            </Grid>
            <Grid item xs={6}>
              <KPTimePicker
                fullWidth
                disabled={disabled}
                label="Ngày cấp bằng"
                value={values?.issueAt || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("issueAt", newValue)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                label="Cơ sở cấp"
                variant="outlined"
                value={values?.issueBy || ""}
                onChange={(event) => handleChangeForm("issueBy", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <KPTimePicker
                fullWidth
                disabled={disabled}
                label="Ngày nộp đơn"
                value={values?.submissionDay || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("submissionDay", newValue)}
              />
            </Grid>
            <Grid item xs={4}>
              <KPTimePicker
                fullWidth
                disabled={disabled}
                label="Ngày chấp nhận đơn"
                value={values?.acceptedDay || "dd/mm/yyyy"}
                setValue={(newValue) => handleChangeForm("acceptedDay", newValue)}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                label="Số (Identification number)"
                variant="outlined"
                value={values?.identificationNumber || ""}
                onChange={(event) => handleChangeForm("identificationNumber", event.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                label="Số lượng trang"
                variant="outlined"
                value={values?.pageNumber || ""}
                onChange={(event) => handleChangeForm("pageNumber", parseInt(event.target.value))}
              />
            </Grid>
            {/* <Grid item xs={2}>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                type="number"
                label="Điểm GS-PGS"
                variant="outlined"
                value={values?.score?.toString() || ""}
                onChange={(event) => handleChangeForm("score", parseFloat(event.target.value))}
              />
            </Grid> */}
            <Grid item xs={4}>
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
              >
                <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Mục đích
                </InputLabel>
                <Select
                  native
                  fullWidth
                  value={values?.purposeId ?? "none"}
                  onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
                >
                  {props.purposes.map((e) => (
                    <option key={e.id} value={e.id}>
                      {e.description}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="type-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                  Loại bằng
                </InputLabel>
                <Select
                  native
                  fullWidth
                  disabled={disabled}
                  labelId="type-label"
                  value={values?.type || ""}
                  onChange={(event) => {
                    const value = event.target.value;
                    handleChangeForm("type", value);
                    if (value !== null) setHelperText(false);
                  }}
                >
                  <option value={null} />
                  <option value="USPTO (Utility)-TGC">USPTO (Utility)-TGC</option>
                  <option value="USPTO (Design)-TGC">USPTO (Design)-TGC</option>
                  <option value="USPTO (Plant)-TGC">USPTO (Plant)-TGC</option>
                  <option value="EPO-TGC">EPO-TGC</option>
                  <option value="Bằng sáng chế (VN)-TGC">Bằng sáng chế (VN)-TGC</option>
                </Select>
                {helperText ? <FormHelperText>Không được để trống</FormHelperText> : null}
              </FormControl>
            </Grid>
            {values?.purposeId === 5 && (
              <>
                <Grid item xs={3}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={timeResearchYear}
                    disabled={disabled}
                    SelectProps={{ native: true }}
                    label="Năm học tính giờ nghiên cứu"
                    variant="outlined"
                    onChange={(event) => {
                      setTimeResearchYear(parseInt(event.target.value));
                      handleChangeForm("timeResearchDetailCode", null);
                    }}
                  >
                    {yearList.map((e) => (
                      <option key={`${e} - ${e + 1}`} value={parseInt(e)}>
                        {e} - {e + 1}
                      </option>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    disabled={disabled}
                    label="Nhiệm vụ tính giờ nghiên cứu"
                    variant="outlined"
                    value={values?.timeResearchDetailCode || null}
                    onChange={(event) => handleChangeForm("timeResearchDetailCode", event.target.value)}
                    InputLabelProps={{
                      shrink: !(
                        values?.timeResearchDetailCode === undefined || values?.timeResearchDetailCode === null
                      ),
                    }}
                    // [VinUni] bỏ bắt buộc chọn loại công trình (không còn tính giờ)
                    error={false}
                  >
                    {timeResearchDetailList.length > 0 ? (
                      timeResearchDetailList?.map((e) => (
                        <MenuItem key={e.code} value={e.code}>{`${e.description}`}</MenuItem>
                      ))
                    ) : (
                      <MenuItem MenuItemvalue={null}>Chưa có dữ liệu</MenuItem>
                    )}
                  </TextField>
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={4}>
                    <Autocomplete
                      disableClearable
                      disabled={disabled}
                      options={props.profileList}
                      getOptionLabel={(option) => option.name}
                      value={props.profileList?.find((profile) => profile.id === e.profileId)}
                      onChange={(event, profile) => {
                        if (profileList[index]?.profileId === values?.profileIdForKpi)
                          handleChangeForm("profileIdForKpi", null);
                        handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth size="small" label="Thành viên" variant="outlined" />
                      )}
                    />
                  </Grid>
                  {/* <Grid item xs={(values?.purposeId !== 1 && values?.purposeId !== 99999999) ? 5 : 3}>
                    <FormControl variant="outlined" size='small' style={{ width: '100%' }}>
                      <InputLabel id="purpose-label" style={{ padding: '0 8px', backgroundColor: 'white' }}>Vai trò</InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId="purpose-label"
                        value={e?.roleInPatent || 'main'}
                        onChange={(event) => handleChangeProfileList(index, 'roleInPatent', event.target.value)}
                      >
                        <option value='main'>Quản lý</option>
                        <option value='member'>Thành viên</option>
                        <option value='other'>Khác</option>
                      </Select>
                    </FormControl>
                  </Grid> */}
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      disabled
                      label="Mã viên chức"
                      variant="outlined"
                      size="small"
                      value={props.profileList?.find((profile) => profile.id === e.profileId)?.code || ""}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      disabled
                      label="Đơn vị"
                      variant="outlined"
                      size="small"
                      value={
                        props.profileList?.find((profile) => profile.id === e.profileId)?.departmentProfile?.[0]
                          ?.department?.name || ""
                      }
                    />
                  </Grid>
                  <Grid item xs={values?.purposeId === 1 || values?.purposeId === 99999999 ? 3 : 4}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInPatent-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò được giao
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId="roleInPatent-label"
                        value={e?.roleInPatent || "main"}
                        onChange={(event) => handleChangeProfileList(index, "roleInPatent", event.target.value)}
                      >
                        <option value="main">Tác giả chính</option>
                        <option value="member">Thành viên</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={values?.purposeId === 1 || values?.purposeId === 99999999 ? 3 : 4}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="statusInProject-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Trạng thái
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        disabled={disabled}
                        labelId="statusInProject-label"
                        value={e?.statusInProject || "K"}
                        onChange={(event) => handleChangeProfileList(index, "statusInProject", event.target.value)}
                      >
                        <option value="NCS">Đang làm NCS</option>
                        <option value="CH">Đang học Cao học</option>
                        <option value="K">Khác</option>
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth disabled={disabled} error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && !disabled && (
                          <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  )}
                  {values?.purposeId === 99999999 && (
                    <Grid item xs={3}>
                      <FormControl fullWidth disabled={disabled} error={!values?.profileIdForReward}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={disabled}
                          startIcon={
                            typeof values?.profileIdForReward === "number" &&
                            values?.profileIdForReward === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForReward",
                              values?.profileIdForReward !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính thưởng
                        </Button>
                        {!values?.profileIdForReward && !disabled && (
                          <FormHelperText>Phải chọn 1 người tính thưởng</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId === 1 || values?.purposeId === 99999999 ? 3 : 4}>
                    <Button
                      fullWidth
                      disabled={disabled}
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth disabled={disabled} variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
          {values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 && (
            <div style={{ marginTop: 16 }}>
              <EmploymentContractTable
                contract={detail}
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                setDetail={setDetail}
                contractList={contractList}
                kpiIdForKpi={values?.kpiIdForKpi}
                contractIdForKpi={values?.contractIdForKpi}
                handleChangeForm={handleChangeForm}
                values={values}
                setValues={setValues}
              />
              <EmploymentContractDetailTable
                disabled={disabled || values?.locked === "kpi" || values?.locked === "reward"}
                kpi={detail}
              />
            </div>
          )}
        </div>
        <div
          style={{
            width: "40%",
            padding: "20px 24px",
            backgroundColor: "#fafafa",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6" gutterBottom>
            File minh chứng
          </Typography>
          <div
            style={{
              backgroundColor: "#ffebee",
              color: "#c62828",
              padding: "12px",
              marginBottom: 16,
              borderRadius: 4,
              whiteSpace: "pre-line",
            }}
          >
            {getNoteByType()}
          </div>
          <DropzoneArea
            filesLimit={1}
            maxFileSize={50000000}
            showPreviews={true}
            showPreviewsInDropzone={false}
            useChipsForPreview
            previewText="File đã chọn:"
            onChange={(files) => setFiles(files)}
            dropzoneText="Kéo thả file vào đây hoặc click để chọn"
          />
          {values?.fileUrl && (
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={handleOpenPreviewModal}
              style={{ marginTop: 16 }}
            >
              Preview file minh chứng hiện tại
            </Button>
          )}
        </div>
      </DialogContent>
      <FilePreviewModal open={previewModalOpen} handleClose={handleClosePreviewModal} url={values?.fileUrl} />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  history: select(state, "homeReducer", "history"),
  profile: select(state, "profileReducer", "detail"),
  fileUrl: select(state, "fileReducer", "fileUrl"),
  profileList: select(state, "profileReducer", "list"),
  isUploading: select(state, "fileReducer", "isFetching"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  employmentContractDetail: select(state, "employmentContractReducer", "detail"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
  timeResearchInformationList: select(state, "timeResearchInformationReducer", "list"),
  isFetchingTimeResearch: select(state, "timeResearchInformationReducer", "isFetching"),
  isFetchingEmploymentContract: select(state, "employmentContractReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  updatePatent: (id, payload) => dispatch(updatePatent(id, payload)),
  acceptPatent: (id, accept) => dispatch(acceptPatent(id, accept)),
  requestRevisionPatent: (id, reason) => dispatch(requestRevisionPatent(id, reason)),
  uploadFile: (id, type, file) => dispatch(uploadFile(id, type, file)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  getEmploymentContractById: (id) => dispatch(getEmploymentContractById(id)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(PatentUpdateModal));

